module.exports = __webpack_public_path__ + "img/wb_ic_speech.389ccc84.svg";